export interface DomainContext {
  domainId: string;
  domainHandle: string;
  domainName?: string;
}

export interface UserDomainInfo {
  domain_id: string;
  domain_handle: string;
  role: string;
}

const TEAM_ROOM_SEPARATOR = '--';

export function isTeamRoomName(roomName: string): boolean {
  return roomName.includes(TEAM_ROOM_SEPARATOR);
}

export function parseTeamRoomName(roomName: string): { domainHandle: string; memberHandle: string } | null {
  if (!isTeamRoomName(roomName)) return null;

  let baseName = roomName;
  if (baseName.startsWith('interview-')) {
    baseName = baseName.replace(/^interview-/, '');
  }
  baseName = baseName.replace(/-b-.*$/, '').replace(/-\d+$/, '');

  const separatorIndex = baseName.indexOf(TEAM_ROOM_SEPARATOR);
  if (separatorIndex === -1) return null;

  return {
    domainHandle: baseName.substring(0, separatorIndex),
    memberHandle: baseName.substring(separatorIndex + TEAM_ROOM_SEPARATOR.length),
  };
}

export function buildTeamRoomName(domainHandle: string, memberHandle: string): string {
  return `${domainHandle}${TEAM_ROOM_SEPARATOR}${memberHandle}`;
}

export function buildTeamInterviewRoomName(domainHandle: string, memberHandle: string, timestamp: number): string {
  return `interview-${domainHandle}${TEAM_ROOM_SEPARATOR}${memberHandle}-${timestamp}`;
}

export function getRoomUrl(handle: string, activeDomain: UserDomainInfo | null, personalDomainId: string | null): string {
  const isTeamDomain = activeDomain && activeDomain.role !== 'owner' && activeDomain.role !== 'byline';
  if (isTeamDomain) return `/rooms/${activeDomain.domain_handle}/${handle}`;
  return `/rooms/${handle}`;
}

export function getRoomName(handle: string, activeDomain: UserDomainInfo | null, personalDomainId: string | null): string {
  const isTeamDomain = activeDomain && activeDomain.role !== 'owner' && activeDomain.role !== 'byline';
  if (isTeamDomain) return buildTeamRoomName(activeDomain.domain_handle, handle);
  return handle;
}

export function roomNameToUrl(roomName: string): string {
  const parsed = parseTeamRoomName(roomName);
  if (parsed) return `/rooms/${parsed.domainHandle}/${parsed.memberHandle}`;
  return `/rooms/${roomName}`;
}
